import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingMobileCTA from "@/components/FloatingMobileCTA";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import GoogleTags from "@/components/GoogleTags";
import CookieBanner from "@/components/CookieBanner";
import BackToTop from "@/components/BackToTop";
import { rememberLanding } from "@/lib/sessionTracking";
import { installGlobalClickTracking } from "@/lib/track";

// Capture the landing path once per browser tab.
rememberLanding();
// Global click delegation: click_phone / click_whatsapp on every tel:/wa.me.
installGlobalClickTracking();

const Layout = () => {
    const location = useLocation();

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <div className="min-h-screen flex flex-col bg-white" data-testid="app-layout">
            <GoogleTags />
            <Header />
            <main className="flex-1 pb-20 md:pb-0">
                <Outlet />
            </main>
            <Footer />
            <FloatingMobileCTA />
            <FloatingWhatsApp />
            <BackToTop />
            <CookieBanner />
        </div>
    );
};

export default Layout;
